import { preserveCanvasScroll } from "@/lib/cms-puck/preserve-canvas-scroll";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { ComponentProps } from "react";

type PuckSafeSelectProps = ComponentProps<typeof Select>;

/**
 * Select Radix encapsulé pour l'éditeur CMS avancé : préserve le scroll du canvas à
 * l'ouverture (évite le « reload » / remontée en haut du canva).
 */
export function PuckSafeSelect({
  onOpenChange,
  ...props
}: PuckSafeSelectProps) {
  return (
    <Select
      {...props}
      onOpenChange={(open) => {
        if (open) preserveCanvasScroll();
        onOpenChange?.(open);
      }}
    />
  );
}

export {
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
};
